import script from "./Templates.vue?vue&type=script&setup=true&lang=js"
export * from "./Templates.vue?vue&type=script&setup=true&lang=js"

import "./Templates.vue?vue&type=style&index=0&id=2351aaab&lang=scss"

const __exports__ = script;

export default __exports__